import CountryService from "app/services/CountryService";

import { createColumnsService } from "./columnsService";

const ColumnsService = createColumnsService(CountryService);

export default ColumnsService;
